/** @jsxImportSource @emotion/react */
import { useTheme } from '@mui/material'
import React from 'react'
import { HeroImage } from '../types/guide.types'
import { cn } from '@/lib/tailwind.utils'

type ImageSize = 'thumbnail' | 'small' | 'medium' | 'large' | 'original'

interface StrapiImageProps {
  image?: HeroImage
  src?: string | HeroImage
  size?: ImageSize
  alt?: string
  className?: string
  strapiUrl?: string
}

const StrapiImage: React.FC<StrapiImageProps> = ({
  image,
  src,
  size = 'medium',
  alt,
  className = '',
}) => {
  // Determine the image source
  let imageSrc = src
  let imageAlt = alt

  if (image) {
    if (size === 'original') {
      imageSrc = image.url
    } else {
      imageSrc = image.formats[size]?.url || image.url
    }

    imageAlt = alt || image.alternativeText || ''
  }

  if (!imageSrc) return null

  return (
    <img
      src={src as string}
      alt={imageAlt}
      className={cn(
        'block h-[300px] w-full rounded-2xl object-cover object-[50%_80%] shadow-sm md:h-[350px] sm:h-[200px]',
        className,
      )}
    />
  )
}

export default StrapiImage
